export enum IconNames {
  "Smile" = "Smile",
  "BackArrow" = "BackArrow",
  "QuestionCircle" = "QuestionCircle",
  "Dislike" = "Dislike",
  "Like" = "Like",
  "Facebook" = "Facebook",
  "WarningCircle" = "WarningCircle",
  "PauseCircle" = "PauseCircle",
  "QRCode" = "QRCode",
  "Settings" = "Settings",
  "Instagram" = "Instagram",
  "Verified" = "Verified",
  "VIP" = "VIP",
  "VK" = "VK",
  "OK" = "OK",
  "Checkmark" = "Checkmark",
  "Karma" = "Karma",
  "NotActiveKarma" = "NotActiveKarma",
  "ActiveKarma" = "ActiveKarma",
  "Trash" = "Trash",
  "Dots" = "Dots",
  "Add" = "Add",
  "AddAvatar" = "AddAvatar",
  "Cross" = "Cross",
  "Photo" = "Photo",
  "Send" = "Send",
  "Star" = "Star",
  "Option" = "Option",
  "PuffLoader" = "PuffLoader",
  "Typing" = "Typing",
  "RevertArrow" = "RevertArrow",
  "DotsLoader" = "DotsLoader",
  "Rocket" = "Rocket",
  "ArrowWithoutTail" = "ArrowWithoutTail",
  "Official" = "Official",
  "Apple" = "Apple",
  "GooglePlay" = "GooglePlay",
  "Gif" = "Gif",
  "Search" = "Search",
  "EyeOpened" = "EyeOpened",
  "EyeClosed" = "EyeClosed",
  "Folder" = "Folder",
  "Attention" = "Attention",
  "Bell" = "Bell",
  "Telegram" = "Telegram",
  "Dash" = "Dash",
  "SettingsSmall" = "SettingsSmall",
  "Translator" = "Translator",
  "SadFace" = "SadFace",
  "Male" = "Male",
  "Female" = "Female",
  "Filters" = "Filters",
}

export type IconProps = {
  width?: number;
  height?: number;
  viewBox?: string;
  color?: string;
  secondaryColor?: string;
  ["data-cy"]?: string;
  hover?: boolean;
  className?: string;
};
